export const formControlToFilter = (val: string): string => {
  return val ? val.replace('-', '.') : '';
};

export const filterToFormControl = (val: string): string => {
  return val ? val.replace('.', '-') : '';
};
